import {
  Button,
  Card,
  Form,
  Input,
  message,
  Tooltip,
} from "antd";
import "../styles/index.css";
import { useState, useEffect } from "react";
import BillCard from "./BillPage";
import { TelenganaNorthenApiService } from "../httpsservice/ApiService";
import { InfoCircleOutlined } from "@ant-design/icons";
import backHomeLogo from "../static/back-home-tgnpdcl-logo.svg";
import checkBillHistoryLogo from "../static/check-bill-history-logo.svg";

const UniqueServicePageTGN = () => {
  const [showBill, setShowBill] = useState(false);
  const [billData, setBillData] = useState(null);
  const [form] = Form.useForm();

  useEffect(() => {
    const gtagScript = document.createElement("script");
    gtagScript.async = true;
    gtagScript.src = "https://www.googletagmanager.com/gtag/js?id=G-3PMGZX6W75";
    document.head.appendChild(gtagScript);

    const inlineScript = document.createElement("script");
    inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-3PMGZX6W75');
    `;
    document.head.appendChild(inlineScript);
  }, []);

  const [messageApi, contextHolder] = message.useMessage();
  const [isFetchLoading, setFetchLoading] = useState(false);
  const [fetchBillBtnDisabled, setFetchBillBtnDisabled] = useState(false);

  const handleSubmit = async () => {
    try {
      await callServiceNumberApi();
    } catch (err) {
      console.error("API call error:", err);
    }
  };

  const isFetchBillBtnDisabled = () => {
    if (
      form.isFieldTouched("service_number") &&
      form.getFieldValue("service_number")?.length === 8
    ) {
      setFetchBillBtnDisabled(false);
      return false;
    } else {
      setFetchBillBtnDisabled(true);
      return true;
    }
  };

  const callServiceNumberApi = async () => {
    setFetchLoading(true);
    const serviceNumber = form.getFieldValue("service_number");

    const queryData = {
      service_number: serviceNumber
    };

    try {
      const response = await TelenganaNorthenApiService.getBillDetails(queryData);

      if (response?.data && response.success) {
        response.data.uniqueSNo = serviceNumber;
        setBillData(response.data);
        setShowBill(true);
        form.setFields([{ name: "service_number", errors: [] }]);
      } else {
        setShowBill(false);
        setBillData(null);
        form.setFields([
          {
            name: "service_number",
            errors: [response?.message || "Failed to fetch bill data"],
          },
        ]);
      }
    } catch (error) {
      console.error("Error fetching bill details:", error);
      setShowBill(false);
      setBillData(null);
      form.setFields([
        {
          name: "service_number",
          errors: ["Service temporarily unavailable. Please try again later."],
        },
      ]);
    }
    setFetchLoading(false);
  };

  const redirectToHomePage = () => {
    const url = "https://tgnpdcl.com/Menu/OnlinePayBIll";
    window.location.href = url;
  };

  return (
    <>
      {contextHolder}
      <div
        className={
          showBill ? "tgnpdcl-main-wrapper-telangana-lg" : "tgnpdcl-main-wrapper-telangana-sm"
        }
      >
        <div
          className={showBill ? "center-container-bill-page" : "center-container-service-number"}
        >
          {!showBill && (
            <div className="tgnpdcl-center-box-bill-tgnpdcl">
              <div className="tgnpdcl-buttons-wrapper">
                <Button
                  size="small"
                  type="text"
                  danger={false}
                  title="Back Home"
                  icon={<img src={backHomeLogo} alt="Back Home" style={{ width: 10.5, height: 10.5 }} />}
                  className="tgnpdcl-back-home-btn"
                  onClick={() => window.open("https://tgnpdcl.com/Menu/OnlinePayBIll", "_blank", "noopener,noreferrer")}
                >
                  Back Home
                </Button>

                <Button
                  size="small"
                  type="text"
                  danger={false}
                  title="Check Bill History"
                  icon={<img src={checkBillHistoryLogo} alt="Back Home" style={{ width: 10.5, height: 10.5 }} />}
                  className="tgnpdcl-bill-history-btn"
                  onClick={() =>
                    window.open(
                      "http://210.212.223.83:9000/EBS/Consumer Management/OnlinePayCheck.jsp",
                      "_blank",
                      "noopener,noreferrer"
                    )
                  }
                >
                  Check Bill History
                </Button>
              </div>
              <Card
                className="tgnpdcl-service-number-card-tgnpdcl"
                cover={
                  <div className="tgnpdcl-tel-north-logo-main">
                    <img
                      alt="TGNPDCL"
                      className="tgnpdcl-logo"
                      src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/tel-north-main-logo.svg"
                      style={{ width: '51.5px', height: '46px' }}
                    />
                    <span className="tgnpdcl-elecricity-title">
                      NORTHERN POWER DISTRIBUTION COMPANY OF TELANGANA LIMITED
                    </span>
                  </div>
                }
              >
                <div className="tgnpdcl-card-body-container-tgnpadcl">
                  <h1 className="tgnpdcl-page-h1">Pay TGNPDCL Electricity Bill Online</h1>
                  <Card className="tgnpdcl-form-card">
                    <Form form={form} onFinish={handleSubmit} className="tgnpdcl-form">

                      <div className="service-number-input-tdnpdcl">
                        <div className="tgnpdcl-service-number-label-wrapper">
                          <span>Unique Service number<sup style={{ color: "red" }}>*</sup></span>
                          <div className="tooltip-wrapper">
                            <Tooltip 
                              title={<span className="tooltip-text">Allowed characters (0-9) Maximum length: 8</span>}
                              overlayInnerStyle={{
                                width: '196px',
                                height: '62.31px',
                                borderRadius: '2px',
                                paddingBottom: '14.31px',
                                background: '#2A2A2A',
                                boxShadow: '0px 2px 8px 0px #00000026'
                              }}
                            >
                              <InfoCircleOutlined className="tgnpdcl-tooltip-icon" />
                            </Tooltip>
                          </div>
                        </div>

                        <Form.Item
                          name="service_number"
                          rules={[
                            {
                              required: true,
                              message: "Invalid service number",
                            },
                            {
                              pattern: /^\d{8}$/,
                              message: "Invalid service number",
                            },
                          ]}
                        >
                          <Input
                            className="tgnpdcl-service-number-input-box"
                            size="large"
                            maxLength={8}
                            placeholder={window.innerWidth <= 768 ? "Enter a 8 digit Unique Service Number" : "Enter a 8 digit Unique Service Number(uscno)"}
                            onChange={(e) => {
                              const value = e.target.value.replace(/[^\d]/g, "");
                              form.setFieldsValue({ service_number: value });
                              form.validateFields(["service_number"]);
                            }}
                          />
                        </Form.Item>
                      </div>

                      <Form.Item shouldUpdate>
                        {() => (
                          <Button
                            className="tgnpdcl-fetch-bill-btn-tgnpdcl"
                            size="large"
                            block
                            htmlType="submit"
                            loading={isFetchLoading}
                            disabled={isFetchBillBtnDisabled()}
                          >
                            Show Bill
                          </Button>
                        )}
                      </Form.Item>
                    </Form>
                  </Card>
                </div>
              </Card>
              <img
                alt="poweredby-easebuzz-logo"
                className="tgnpdcl-poweredby-easebuzz-logo"
                src="https://ebz-static.s3.ap-south-1.amazonaws.com/layer/poweredbyeasebuzz.png"
              />
            </div>
          )}

          {showBill && billData && <BillCard billData={billData} />}
        </div>
      </div>
    </>
  );
};

export default UniqueServicePageTGN;
